import { Detail } from './Detail';

export class BaseModel extends Detail {
    id: number;
    codice: string;
    descrizione: string;
    isActive: boolean;
}
